import React, { useContext } from "react";
import { SelectButton } from "primereact/selectbutton";
import { SettingsContext } from "./SettingsContext.tsx";
import { MissingNumberOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * Whether a math-fact sheet leaves a cell blank: 7 + ___ = 12.
 *
 * Off is the ordinary worksheet. First / Second Number pin which operand is
 * hidden; Mixed alternates the two. The answer is never the blank - a sheet
 * that hid it would just be the ordinary worksheet (ADR 0005 s4).
 *
 * Sits beside Regrouping rather than in AdditionSubtractionSettings, because it
 * applies to all four operations and that panel only shows for add/subtract.
 */
export function MissingNumberSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleChange(value: MissingNumberOptions) {
        // SelectButton hands back null when the current option is clicked again;
        // a sheet is always some option, so Off stands in for "no selection".
        setSettings({ ...settings, MissingNumber: value ?? MissingNumberOptions.Off });
    }

    return (
        <div className="missingNumberContainer">
            <span className="settingLabel">{t('settings.missingNumberLabel')}</span>
            <SelectButton
                value={settings.MissingNumber}
                onChange={(e) => handleChange(e.value)}
                options={withLabels(Object.values(MissingNumberOptions), settings.Language)}
                className="select"
                aria-label={t('settings.missingNumberAria')}
            />
        </div>
    );
}

export default MissingNumberSettings;
